// Each time we request a Gist, we’ll need to generate a new
// global function name to serve as the JSONP callback.
let gistCallbackId = 0;
const nextGistCallback = () => {
    return 'embed_gist_callback_' + gistCallbackId++;
};
let stylesheetAdded = false;
function addStylesheet(href) {
    if (!stylesheetAdded) {
        stylesheetAdded = true;
        const link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = href;
        document.head.appendChild(link);
    }
}
export async function loadGist(gistSrc, placeholder) {
    const gistCallback = nextGistCallback();
    // This is called when gist data has loaded.
    // @ts-ignore
    window[gistCallback] = function (gist) {
        addStylesheet(gist.stylesheet);
        placeholder.insertAdjacentHTML('afterend', gist.div);
    };
    //create json url
    const jsonUrl = `${gistSrc}on?callback=${gistCallback}`;
    // Add the JSONP script tag to the document.
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = jsonUrl;
    // script.onerror
    document.head.appendChild(script);
}
//# sourceMappingURL=InnerHtmlGist.js.map